import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbConfigDispositivo } from 'app/abstract/full-pages/locker/config-dispositivo.abstract';

@Injectable({ providedIn: 'root' })
export class ConfigDispositivoService extends AbConfigDispositivo {

  constructor(http: HttpClient) {
    super(http);
  }

  public getConfigDispositivo(dispositivoId: number) {
    return this.get(`config_dispositivos/dispositivo/${dispositivoId}`);
  }

  public salvar(entity: any) {
    return this.save("config_dispositivos/", entity);
  }
}